<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 512 512"
>
  <path
    d="M256 106.667 114.325 224.704l27.328 32.79 93.014-77.505V448h42.666V179.99l92.992 77.503 27.328-32.789L256 106.667Zm-170.667 0h341.334V64H85.333v42.667Z"
    fill="#ffffff"
  />
</svg>
